import api from "./core";

const basePath = "api/core/CareBedAssignment";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter) {
    return api.post(`${basePath}`, filter);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  }
};
